<h2 mat-dialog-title>GPT Report</h2>
<mat-dialog-content class="mat-typography">
  <ag-grid-angular
    class="ag-theme-alpine"
    style="height: 500px;"
    [defaultColDef]="defaultColDef"
    [pagination]="false"
    [paginationPageSize]="100000"
    [getContextMenuItems]="getGptContextMenuItems"
    [cacheBlockSize]="100000"
    [maxBlocksInCache]="20"
    [maxConcurrentDatasourceRequests]="1"
    [rowModelType]="'serverSide'"
    [columnDefs]="columnDefs"
    [rowData]="rowData"
    (gridReady)="onGridReady($event)"
  ></ag-grid-angular>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
